import {
  getInstitutes,
  getBranches,
  getBatches,
  getAdminList,
  getBranchList,
  getAvailableCourses,
  getWebexUsers,
  saveBranch,
  editBranch,
  deleteBranch,
  getBranchById,
  getInstituteList,
  deleteInstitute,
  getAdditionalCourses,
  getInstituteById,
  getCourses,
  editInstitute,
  addInstitute,
  getCoachingCenter
} from './api'
import { userSlice } from './reducer'

const {
  selectAdmin,
  resetBranch,
  resetInstitutes,
  resetInstitute,
  resetAvailableCourse
} = userSlice.actions

export {
  getInstitutes,
  getBranches,
  getBatches,
  getAdminList,
  selectAdmin,
  getBranchList,
  getAvailableCourses,
  getWebexUsers,
  saveBranch,
  editBranch,
  deleteBranch,
  resetBranch,
  getBranchById,
  resetInstitutes,
  getInstituteList,
  deleteInstitute,
  getAdditionalCourses,
  getInstituteById,
  resetInstitute,
  getCourses,
  editInstitute,
  addInstitute,
  resetAvailableCourse,
  getCoachingCenter
}
